import { Img } from "@react-email/components";
import { isOurTenant } from "@/store/tenant/selectors";
import { ITenant } from "@/types/tenant";

export const EmailLogo = ({ tenant }: { tenant: ITenant | null }) => {
    const tenantPrimaryImage = tenant?.images?.primaryLogo;
    const is1TemplateTenant = isOurTenant(tenant);

    if (!tenantPrimaryImage && !is1TemplateTenant) {
        return null;
    }

    const src = is1TemplateTenant
        ? "https://s3.ap-southeast-2.amazonaws.com/1template.com/static/logo/1template-logo-full-white.png"
        : tenantPrimaryImage;

    return (
        <Img
            src={src}
            height={32}
            alt={tenant?.name}
            style={{ margin: "0 auto 36px" }}
        />
    );
};
